export function getLastItem<T>(items: T[]): T {
    return items.length === 0 ? undefined : items[items.length - 1];
}
